export default __webpack_public_path__ + "app/images/theme-images/shared/video-play-btn/icon-24-play-fill@2x.webp";